<template>
  <div class="container" id="top-page">
    <v-expansion-panels multiple v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="Header"
          >Inventory Management</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search1"
          />
          <!-- <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate1" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate1" class="input_date" />
            </div>
          </div> -->
          <br />
          <v-data-table
            v-if="headerItemsFilterDate.length <= 0"
            item-key="name"
            class="elevation-1 table-header"
            loading
            hide-default-footer
            :headers="headersNotfound"
            :items-per-page="5"
            :items="itemNotfound"
            loading-text="Loading... Please wait"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              />
            </template>
          </v-data-table>
          <v-data-table
            v-else
            :headers="invHeader"
            :items="headerItemsFilterDate"
            :items-per-page="5"
            hide-default-footer
            class="elevation-1 table-header"
            @click:row="handleRowClick"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              />
              <v-dialog v-model="dialog" max-width="750px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Inventory Information</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <div v-for="(header, idx) in invHeader" :key="idx">
                          <v-col cols="auto" sm="auto" md="auto">
                            <v-text-field
                              color="black"
                              v-if="checkIsEmpty(curInv[header.value])"
                              v-model="emptyItem"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                            <v-text-field
                              color="black"
                              v-else
                              v-model="curInv[header.value]"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                          </v-col>
                        </div>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn color="blue darken-1" text @click="close">
                      OK
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template
              v-for="header in invHeader"
              v-slot:[`item.${header.value}`]="{ item }"
            >
              <template v-if="isBoolean(item[header.value])">
                <div class="checkbox_container" v-bind:key="item[header.value]">
                  <v-checkbox
                    v-bind:key="item[header.value]"
                    v-model="item[header.value]"
                    :true-value="true"
                    :false-value="false"
                    light
                    disabled
                    color="black"
                  ></v-checkbox>
                </div>
              </template>
              <template v-else>
                {{ item[header.value] }}
              </template>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
// import tableComponent from "../table/tableComponent.vue";
import { mapGetters } from "vuex";
import DecodeJWT from "../DecodeJWT";

export default {
  // components: { tableComponent },
  mounted() {
    let token = localStorage.getItem("token");
    if (token == "" || !token) {
      this.$router.push("/login");
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push("/login");
      } else {
        window.scrollTo({
          top: document.getElementById("top-page").offsetTop,
          left: 0,
          behavior: "smooth",
        });
        this.panel = Array.from(Array(2).keys());
        this.getBAQInventory();
        const today = new Date();
        const fromday = new Date();
        fromday.setMonth(fromday.getMonth() - 3);
        let year = today.getFullYear();
        let month = (today.getMonth() + 1).toString().padStart(2, "0");
        let day = today.getDate().toString().padStart(2, "0");
        this.todate1 = this.todate2 = `${year}-${month}-${day}`;
        year = fromday.getFullYear();
        month = (fromday.getMonth() + 1).toString().padStart(2, "0");
        day = fromday.getDate().toString().padStart(2, "0");
        this.fromdate1 = this.fromdate2 = `${year}-${month}-${day}`;
      }
    }
  },
  data() {
    return {
      headersNotfound: [{ text: "", value: "nf" }],
      itemNotfound: [{ nf: "Data not found!" }],
      invHeader: [
        { text: "Company", value: "PartBin_Company" },
        { text: "Part Num", value: "PartBin_PartNum" },
        { text: "Warehouse Code", value: "PartBin_WarehouseCode" },
        { text: "BinNum", value: "PartBin_BinNum" },
        { text: "Onhand Quantity", value: "PartBin_OnhandQty" },
        { text: "LotNum", value: "PartBin_LotNum" },
      ],
      invDetail: [],
      headerItems: [],
      detailItems: [],
      panel: [],
      curInv: {},
      dialog: false,
      emptyItem: " ",
      search1: "",
      search2: "",
      fromdate1: "",
      todate1: "",
      fromdate2: "",
      todate2: "",
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    getInventory() {
      this.loadHeader();
    },
  },
  computed: {
    ...mapGetters("User", ["getUserInfo"]),
    ...mapGetters("Data", ["getInventory"]),
    headerItemsFilter() {
      const filterKey = (this.search1 || "").toLowerCase();
      if (this.headerItems == null || filterKey === "") return this.headerItems;
      return this.headerItems.filter((i) => {
        return (
          i.PartBin_PartNum.toString().toLowerCase().indexOf(filterKey) > -1
        );
      });
    },
    headerItemsFilterDate() {
      if (this.headerItemsFilter.length > 0) {
        // let from = new Date(this.fromdate1);
        // let to = new Date(this.todate1);
        // return this.headerItemsFilter.filter((i) => {
        //   let day = i.ShipHead_ShipDate.split("/")[0];
        //   let month = i.ShipHead_ShipDate.split("/")[1];
        //   let year = i.ShipHead_ShipDate.split("/")[2];
        //   let date = new Date(year, month - 1, day);
        //   return date <= to && from <= date;
        // });
        return this.headerItemsFilter;
      } else {
        return this.headerItemsFilter;
      }
    },
    // detailItemsFilter() {
    //   const filterKey = (this.search2 || "").toLowerCase();
    //   if (this.detailItems == null || filterKey === "") return this.detailItems;
    //   return this.detailItems.filter((i) => {
    //     return (
    //       i.ShipDtl_PackLine.toString().toLowerCase().indexOf(filterKey) > -1 ||
    //       i.Calculated_Order.toString().toLowerCase().indexOf(filterKey) > -1
    //     );
    //   });
    // },
    // detailItemsFilterDate() {
    //   if (this.detailItemsFilter.length > 0) {
    //     // let from = new Date(this.fromdate2);
    //     // let to = new Date(this.todate2)
    //     // return this.detailItemsFilter.filter((i) => {
    //     //   let day = i.InvcHead_InvoiceDate.split('/')[0];
    //     //   let month = i.InvcHead_InvoiceDate.split('/')[1];
    //     //   let year = i.InvcHead_InvoiceDate.split('/')[2];
    //     //   let date = new Date(year, month-1, day);
    //     //   return date <= to && from <= date;
    //     // });
    //     return this.detailItemsFilter;
    //   } else {
    //     return this.detailItemsFilter;
    //   }
    // },
  },
  methods: {
    isBoolean(value) {
      return typeof value === "boolean";
    },
    checkIsEmpty(value) {
      if (typeof value === "string") {
        if (value.length == 0) return true;
        return false;
      }
      if (typeof value === "boolean") {
        return false;
      }
      return false;
    },
    close() {
      this.dialog = false;
    },
    handleRowClick(item) {
      this.curInv = item;
      this.dialog = true;
    },
    convertDate(stringdate) {
      if (stringdate) {
        var dateObject = new Date(stringdate);
        var day = dateObject.getDate().toString().padStart(2, "0");
        var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
        var year = dateObject.getFullYear();
        return `${day}/${month}/${year}`;
      } else return "";
    },
    async getBAQInventory() {
      await this.$store.dispatch("Data/getInventoryData");
      this.loadHeader();
    },
    loadHeader() {
      this.headerItems = [];
      if (this.getInventory && this.getInventory.length > 0) {
        this.getInventory.forEach((el) => {
          this.headerItems.push({
            PartBin_Company: el.PartBin_Company,
            PartBin_PartNum: el.PartBin_PartNum,
            PartBin_WarehouseCode: el.PartBin_WarehouseCode,
            PartBin_BinNum: el.PartBin_BinNum,
            PartBin_OnhandQty: el.PartBin_OnhandQty,
            PartBin_LotNum: el.PartBin_LotNum,
          });
        });
      }
    },
  },
};
</script>

<style>
.text-start.sortable {
  border: 1px solid black;
  border-bottom: 1px solid black;
  background-color: #c1e4f7;
  height: 50px !important;
}
tr:nth-child(even) {
  background-color: #edf9ff;
  white-space: nowrap;
}
.text-start {
  height: 48px;
}

.text-start .checkbox_container {
  margin-left: 28%;
}

.v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 48px !important;
}

.table td {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.min-width {
  min-width: 500px;
}

.min-width2 {
  min-width: 250px;
}

.v-data-table {
  overflow-x: auto;
  overflow-y: auto;
}

tr:nth-child(odd) {
  white-space: nowrap;
}

table,
th,
td {
  border: 1px solid #e2e2e2;
  border-collapse: collapse;
}

th {
  border-bottom: 2px solid black;
}

td {
  text-align: center;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: thin solid black !important;
}

.table td {
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ml-20 {
  margin-left: 100px;
}
.input_date {
  outline: #d1dfe3;
}
.filter_date {
  display: flex;
  flex-direction: row;
}
.filter_date_item {
  display: flex;
  flex-direction: column;
}
.mb-20 {
  margin-bottom: 50px;
}
.table-custom {
  width: 100%;
  margin-top: 20px;
}
table,
th,
td {
  border: 1px solid #ddd;
  height: 50px;
  border-collapse: collapse;
}
th {
  border-bottom: 2px solid black;
}
td {
  text-align: center;
}
.Header {
  font-weight: 700;
  font-size: 1.2em;
  color: white;
  background-color: #d1dfe3;
  color: black;
}
.input-search {
  margin-top: 5px;
  margin-bottom: 10px;
  outline: #d1dfe3;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}
.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}
</style>
